export default "__VITE_ASSET__BvgTBMGZ__"